// extracted by mini-css-extract-plugin
export var cardContainer = "_nu-0";
export var cardHeader = "_nu-2";
export var collapsedState = "_nu-3";
export var dragHandle = "_nu-5";
export var dragHandleIcon = "_nu-6";
export var dragging = "_nu-1";
export var titleArea = "_nu-4";